module.exports = __webpack_public_path__ + "img/ARKHAN.9b118da0.png";